export default defineNuxtPlugin(async (nuxtApp) => {
    const { default: VOtpInput } = await import("vue3-otp-input");

    nuxtApp.vueApp.component('VOtpInput', VOtpInput);

    return {
        provide: {
            VOtpInput
        },
    }
})
